import axios from 'axios'
import {useState, useEffect} from 'react';
import {useParams} from 'react-router';
import './Stylesheets/Global.css';




export default function Post(){


    interface PostContent{
        postBody: string,
        postTitle: string,
        imageSrc: string
    }


    const backend_url = process.env.REACT_APP_BACKEND_URL;

    const [post, setPost] = useState<PostContent>();

    // Retrieve PostId from URL
    let params = useParams();

    
    // // validate user session
    // useEffect(() => {
    //     // GET Post to process sesssion
    //     axios.get('/Login/ProcessSession', {withCredentials: true})
    //     .then(res => {
    //         // unauthroized code : 401
    //         if(res.status == 401) {
    //             console.log("Unauthorized.");
    //             // Redirect to admin login page
    //             navigate('/adminlogin')
    //         }
    //     })
    // })

    // Retrieve PostID 
    useEffect(() => {

        axios.get(`${backend_url}/Blog/GetPost/${params.postId}`, {withCredentials: true})
        .then(res => {
            setPost(res.data);
        })
        .catch(err => {
            console.log(err.response.data);
        } )

    }, [])


    return(

        <>
        <h1>{post?.postTitle}</h1>
        <h2>{post?.postBody}</h2>
        {/* <img src={`http://localhost:5206/images/posts/${post?.imageSrc}`} /> */}
        </>
    )

}